import Layout from '../components/Layout';

import Orders from '../components/order/Orders';
import AddOrder from '../components/order/AddOrder';
import AddLocation from '../components/location/AddLocation';
import Items from '../components/item/Items';
import AddItem from '../components/item/AddItem';
import EditItem from '../components/item/EditItem';
import Locations from '../components/location/Locations';
import Rates from '../components/Rates';
import Help from '../components/Help';
import LoginForm from '../components/Login';

import {BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom'
import PrivateRoute from '../components/PrivateRoute';

// const useStyles = makeStyles({
//   mainovitch : {
//     fontSize: "170% !important"
//   }
// })

import {ThemeProvider} from "@mui/material"

import { CssBaseline } from '@mui/material';
import { theme } from '../theme';
import EditLocation from '../components/location/EditLocation';
import EditOrder from '../components/order/EditOrder';
import ViewOrder from '../components/order/ViewOrder';
import { useState } from 'react';

// const theme = createTheme({
//   palette : {
//     primary: {
//       main: "#4787e6"
//     },
//     secondary: {
//       main: "#febe39"
//     }
//   },
//   typography: {
//     htmlFontSize: 10
//   }
// })

export default function Home() {
  // const classes = useStyles();

  const [initialTab, setInitialTab] = useState("1");
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
          {/* <div className={classes.mainovitch}> */}
        <Layout>
          <Switch>          
            <PrivateRoute path="/orders" exact component={Orders} initialTab={initialTab} setInitialTab={setInitialTab}/>
            <PrivateRoute path="/orders/add/" exact component={AddOrder} />
            <PrivateRoute path="/orders/add/:id" exact component={AddOrder} />
            <PrivateRoute path="/orders/edit/:id" exact component={EditOrder} />
            <PrivateRoute path="/orders/view/:id" exact component={ViewOrder} />
            <PrivateRoute path="/items" exact component={Items} />
            <PrivateRoute path="/items/add" exact component={AddItem} />
            <PrivateRoute path="/items/add/:id" exact component={AddItem} />
            <PrivateRoute path="/items/edit/:id" exact component={EditItem} />
            <PrivateRoute path="/locations" exact component={Locations} />
            <PrivateRoute path="/locations/add" exact component={AddLocation} />
            <PrivateRoute path="/locations/edit/:id" exact component={EditLocation} />
            <PrivateRoute path="/rates" exact component={Rates} />
            <PrivateRoute path="/help/articles/:articleSlug" exact component={Help} />
            <PrivateRoute path="/help/faq/:faqItemId" exact component={Help} />
            <PrivateRoute path="/help" exact component={Help} />
            {/* <Route path="/pending" exact>
              <Pending />
            </Route> */}
            <Route path="/login" exact> 
              <LoginForm />
            </Route>
            <Route path="/*">
              <Redirect to="/orders"/>
            </Route>
          </Switch>
        </Layout>
          {/* </div> */}
      </Router>
    </ThemeProvider>
  )
}
